export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14364.6a0cbdb4.jpg";